(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cuddle-subscribe"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const box = event.target.closest('[data-cuddle-sub]');
    if (!box) return;
    const subscribe = box.querySelector('[data-cuddle-sub-choice][value="subscribe"]').checked;
    const plans = box.querySelector('[data-cuddle-sub-plans]');
    const select = box.querySelector('[data-cuddle-sub-select]');
    const input = box.querySelector('[data-cuddle-sub-plan]');
    plans.hidden = !subscribe;
    input.disabled = !subscribe;
    input.value = select.value;
  });
  } catch(e) { console.error(e); }
})();

})();
